
    import './styles.scoped.css';
    export default {
  "radio-group": "awsui_radio-group_1mabk_1830o_141",
  "horizontal-group": "awsui_horizontal-group_1mabk_1830o_172",
  "radio": "awsui_radio_1mabk_1830o_141",
  "horizontal": "awsui_horizontal_1mabk_1830o_172",
  "radio--has-description": "awsui_radio--has-description_1mabk_1830o_186"
};
  